


/**
* The type of business that is being done that dictates the AI models to use for photo tagging
*/
export enum AIPhotoTaggingBusinessType{
    /**
    * Main Street Personal Lines
    */
    MainStreetPersonalLines = 0,
    /**
    * High-Value Personal Lines
    */
    HighValuePersonalLines = 1,
    /**
    * MainStreetCommercial
    */
    MainStreetCommercial = 2,
    /**
    * Risk Engineering
    */
    RiskEngineering = 3
}

